import { PanelDef } from 'app/shared/components/panels/panels.types';

export abstract class DashboardUtils {
  static getLaneAndPanelIndexes(
    dashboard: { panels: any[]; tabs: any[] },
    panelDef: PanelDef<any>,
  ): {
    laneIndex: number;
    panelIndex: number;
    tabIndex: number;
  } {
    const { panels, tabs } = dashboard;

    let panelIndex = -1;

    const laneIndex = panels.findIndex((panels: PanelDef<any>[]) => {
      panelIndex = panels.findIndex((panel) => panel.id === panelDef.id);
      return panelIndex > -1;
    });

    let tabIndex = -1;

    if (laneIndex < 0) {
      tabIndex = tabs.findIndex((tab) => {
        panelIndex = tab.panels.findIndex((panel: PanelDef<any>) => panel.id === panelDef.id);
        return panelIndex > -1;
      });
    }

    return { panelIndex, laneIndex, tabIndex };
  }

  static getTabAndPanelIndexes(
    definition: any,
    panelDef: PanelDef<any>,
  ): {
    panelIndex: number;
    tabIndex: number;
  } {
    let tabIndex: number, panelIndex: number;

    for (const [i, tab] of Object.entries(definition.tabs)) {
      panelIndex = (tab as any).layout.findIndex((layout) => layout.id === panelDef.id);

      if (panelIndex !== -1) {
        tabIndex = +i;
        break;
      }
    }

    return { tabIndex, panelIndex };
  }
}
